/**
 * @ngdoc directive
 * @name cbl.finanza.mf.directive:finanzaAbilitaConsulenza
 * @restrict E
 * @scope
 * @description Componente utilizzato per dirottare l'utente all'abilitazione del dossier per la consulenza
 */
(function () {
  'use strict';
  var AbilitaConsulenzaCtrl = function (
    $http,
    $scope,
    $window,
    $q,
    $stateParams,
    $state,
    $location,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    uiGridConstants,
    messaggiSrvc,
    brioSrvc,
    userSrvc,
    deskSrvc,
    ssocoreServices
  ) {
    var self = this;
    this.$http = $http;
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$location = $location;
    this.messaggiFctr = messaggiFctr;
    this.messaggiSrvc = messaggiSrvc;
    this.brioSrvc = brioSrvc;
    this.userSrvc = userSrvc;
    this.ssocoreServices = ssocoreServices;
    this.deskSrvc = deskSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.dossier = {};
    this.portafoglioTableLabel = [];
    this.portafoglioTableData = [];
    this.posizione = {};
    this.spinner = {
      listaPortafoglio: false
    };
    this.domain = {
      listaTipologiaStrumento: []
    };
    this.messaggiFctr.chiudiLoaderBrio();

    /*
     * -------------------------------------
     * START METODI PROMISE PER SERVIZI REST
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name promiseDatiTabellaPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
     * @description Effettua una chiamata http per ricevere la lista del portafoglio associate ad un dossier
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista del portafoglio
     */
    this.promiseDatiTabellaPortafoglio = function () {
      self.spinner.listaPortafoglio = true;
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          self.$stateParams.finCodiceRapporto +
          '/saldi'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDominioStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
     * @description Effettua una chiamata http per ricevere la lista delle tipologie strumento
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista del saldo portafoglio
     */
    this.promiseDominioFiltriStrumento = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDettaglioDossier
     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
     * @description Effettua una chiamata al dettaglio dossier
     * @return {Promise} - Ritorna una promise contenente il dettaglio del dossier
     */
    this.promiseDettaglioDossier = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.DOSSIER +
          self.$stateParams.finCodiceRapporto
      });
    };

    /**
     * @ngdoc method
     * @name promiseCustomerData
     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
     * @description Effettua la chiamata per ricevere il customerdata
     * @return {Promise} - Ritorna una promise contenente il customerdata
     */
    this.promiseCustomerData = function () {
      return self.$http({
        method: 'GET',
        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
        params: {
          rapporto: self.$stateParams.finCodiceRapporto
        }
      });
    };

    /*
     * -----------------------------------
     * END METODI PROMISE PER SERVIZI REST
     * -----------------------------------
     */

    /*
     * ------------------------
     * START INIT LABEL TABELLE
     * ------------------------
     */

    /**
     * @ngdoc method
     * @name initLabelTabellaPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Crea le label e la struttura della tabella del portafoglio
     */
    this.initLabelTabellaPortafoglio = function () {
      self.portafoglioTableLabel = [
        {
          name: $scope.msg('lista.portafoglio.isin'),
          field: 'strumento.isin',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.intestatario'),
          field: 'intestatario',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.tipologia'),
          field: 'strumento.categoriaStrumento.descrizione',
          width: '*',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: self.domain.listaTipologiaStrumento
          }
        },
        {
          name: $scope.msg('lista.portafoglio.descrizione'),
          field: 'strumento.descrizione',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.divisa'),
          field: 'strumento.divisa',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.quantita.disponibile'),
          field: 'quantita',
          cellFilter: 'number : 0',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.quantita'),
          field: 'quantita',
          cellFilter: 'number : 0',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.ctv.euro'),
          field: 'valoreMercatoControvalore',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.rateo.netto.euro'),
          field: 'ctvRateoNettoEuro',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.rateo.lordo.euro'),
          field: 'ctvRateoLordoEuro',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.prezzo.mercato'),
          field: 'prezzoMercato',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.prezzo.medio'),
          field: 'prezzoCarico',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.plus.min'),
          field: 'percPlusMinus',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        }
      ];
    };

    /*
     * ----------------------
     * END INIT LABEL TABELLE
     * ----------------------
     */

    /*
     * -----------------------
     * START METODI CONTROLLER
     * -----------------------
     */

    /**
     * @ngdoc method
     * @name prosegui
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Prosegue nella rotta BRIO per attivare i servizi di consulenza sul dossier corrente
     */
    this.prosegui = function () {
      switch (self.brioSrvc.brioVersion) {
        case 'brio2':
        case 'brio3':
          self.$stateParams.ndg = self.dossier.ndgIntestatario;
          self.$stateParams.numeroRapporto = self.dossier.codiceRapporto;
          self.$stateParams.isSottoprocesso = 0;
          self.$state.go('questionarioMifidConsulenza', self.$stateParams);
          break;
        case 'brio-xc':
          var parametri = [
            {
              chiave: 'ndg',
              valore: self.dossier.ndgIntestatario
            },
            {
              chiave: 'numeroRapporto',
              valore: self.dossier.codiceRapporto
            },
            {
              chiave: 'isSottoprocesso',
              valore: 0
            },
            {
              chiave: 'Stato',
              valore: 'questionarioMifidConsulenza'
            }
          ];
          self.brioSrvc.goTo(
            self.userSrvc.canaleOperativo,
            'questionarioMifidConsulenza',
            parametri
          );
          break;
      }
    };

    /**
     * @ngdoc method
     * @name indietro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Ritorna allo step precedente o ritorna alla rotta della sceltaDossier
     */
    this.back = function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.popEntry();
      }
      self.$state.go(self.sceltaDossierState, self.$stateParams);
    };

    /*
     * ---------------------
     * END METODI CONTROLLER
     * ---------------------
     */

    /*
     * ----------------------------
     * START METODI INIT CONTROLLER
     * ----------------------------
     */

    // Chiamo il getDossier per inserire le info nel customerdata
    self.promiseCustomerData().then(
      function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          self.posizione = {};
          return;
        }
        self.posizione = response.data;
      },
      function (reason) {
        self.messaggiFctr.processaResponse(reason);
      }
    );

    $q.all({
      portafoglio: self.promiseDatiTabellaPortafoglio(),
      filtriStrumento: self.promiseDominioFiltriStrumento(),
      dossier: self.promiseDettaglioDossier()
    })
      .then(
        function (response) {
          if (
            self.messaggiFctr.processaResponse(response.portafoglio) ||
            self.messaggiFctr.processaResponse(response.filtriStrumento) ||
            self.messaggiFctr.processaResponse(response.dossier)
          ) {
            self.portafoglioTableData = [];
            self.domain.listaTipologiaStrumento = [];
            self.dossier = {};
            return;
          }
          response.filtriStrumento.data.result.forEach(function (item) {
            self.domain.listaTipologiaStrumento.push({
              label: item.descrizione,
              value: item.codice
            });
          });
          self.initLabelTabellaPortafoglio();
          self.portafoglioTableData = response.portafoglio.data.result;
          self.dossier = response.dossier.data.result;
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason.filtriStrumento);
          self.messaggiFctr.processaResponse(reason.portafoglio);
          self.messaggiFctr.processaResponse(reason.dossier);
          self.portafoglioTableData = [];
          self.domain.listaTipologiaStrumento = [];
          self.dossier = {};
        }
      )
      .finally(function () {
        self.spinner.listaPortafoglio = false;
      });

    /*
     * --------------------------
     * END METODI INIT CONTROLLER
     * --------------------------
     */

    if (self.deskSrvc.isDesk) {
      labelSrvc.labelsPronte.then(function () {
        self.deskSrvc.aggiungiEntry(
          labelSrvc.getLabel('lista.scelta.dossier.abilita.consulenza')
        );
      });
    }
  };

  AbilitaConsulenzaCtrl.$inject = [
    '$http',
    '$scope',
    '$window',
    '$q',
    '$stateParams',
    '$state',
    '$location',
    'FIN_CONSTANTS',
    'FinLabelSrvc',
    'FinMessaggiFctr',
    'uiGridConstants',
    'CblMessageSrvc',
    'FinBrioSrvc',
    'FinUserSrvc',
    'FinDeskSrvc',
    'ssocoreServices'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'abilitaConsulenza/abilitaConsulenza.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var AbilitaConsulenzaComponent = {
    bindings: {
      sceltaDossierState: '@'
    },
    controller: AbilitaConsulenzaCtrl,
    controllerAs: 'abilitaConsulenzaCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaAbilitaConsulenza', AbilitaConsulenzaComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/abilitaConsulenza/abilitaConsulenza.cmpt.js
 ** module id = 15
 ** module chunks = 0 1 2
 **/